<template>
    <div>
        <div class="navigation">
            <div class="parentMenuName">{{parentMenuName}}</div>
            <el-scrollbar style="height: 94%;">
                <div class="navList">
                    <el-menu :mode="'vertical'"
                             :default-active="$store.state.menuActiveId"
                             background-color="#fff"
                             text-color="#333"
                             active-text-color="#006fec" class="menuClass">
                        <sub-menu
                            v-for="menu in subMenuList"
                            :key="menu.uuid"
                            :menu="menu" class="common_left_submenuClass">>
                        </sub-menu>
                    </el-menu>
                </div>
            </el-scrollbar>
        </div>
    </div>
</template>

<script>
    import { getMenuList } from "../../utils/interface";
    import SubMenu from './common_left_submenu'
    export default {
        name: "common_left",
        data() {
            return {
                navListNew:[],
                subMenuList: {},
                parentMenuName: ''
            }
        },
        components: {SubMenu},
        created() {
            this.navListNew = JSON.parse(window.sessionStorage.getItem('menuList') || '[]')
            this.routeHandle(this.$route);
        },
        watch:{
            '$route.path':{
                handler(){
                    this.routeHandle(this.$route)
                },
                immediate: true
            },
        },
        methods: {
            // 路由刷新定向
            routeHandle(route) {
                if(route.path == "/home") this.$store.commit('upDateHasSubMenu', false)

                // 获取当前选中父路由下的子菜单
                let parentMenuId = sessionStorage.getItem('parentMenuId')?sessionStorage.getItem('parentMenuId'):'0'
                this.navListNew.some(item => {
                    if(item.uuid === parentMenuId){
                        this.parentMenuName = item.name;
                        this.subMenuList = item.children?item.children:[];

                        if(this.subMenuList.length > 0){
                            this.childrenRoute(this.subMenuList,route);
                        } else {
                            if (item.url === route.fullPath) {
                                this.$router.push(item.url);
                                this.$store.commit('updateMenuActiveId', item.uuid);
                                this.$store.commit('upDateMenuActiveName', item.name);
                                return true
                            }
                        }
                    }
                })
            },
            // 子菜单刷新
            childrenRoute(children,route,item){
                if(children){
                    children.some(sub=>{
                        if (sub.url === route.fullPath) {
                            this.$router.push(sub.url);
                            this.$store.commit('updateMenuActiveId', sub.uuid);
                            this.$store.commit('upDateMenuActiveName', sub.name);
                            return true
                        } else {
                            this.childrenRoute(sub.children,route)
                        }
                    })
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .navigation {
        width: 200px;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: #fff;
        padding: 60px 0 0;
        .parentMenuName{
            padding: 10px 36px 20px 20px;
            font-size: 16px;
            text-align: left;
            line-height: 20px;
            color: #252b3a;
            margin-bottom: 10px;
            position: relative;
            &:after {
                position: absolute;
                bottom: 0;
                left: 20px;
                content: "";
                border: solid #dfe1e6;
                border-width: 0 0 1px;
                width: calc(100% - 56px);
            }
        }
        .navList {
            width: 100%;
            
            /deep/ .el-menu {
                border: none;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/layout/common_left.vue